import { Accordion, ButtonText } from '@morressier/alembic';
import {
  faArrowsRotate,
  faBell,
  faHourglassHalf
} from '@fortawesome/pro-regular-svg-icons';
import { useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ExtendSubmissionDeadlineModal } from '../../../decisionModals/GrantSubmissionExtensionModal';
import { calculateDaysToDeadline } from 'src/utils/deadlines';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { EditorialTransferOfferContextModal } from 'src/components/Submission/modals/editorial/TransferOfferContext';
import { IconBadge } from 'src/components/IconBadge';
import { EditorialAuthorWithdrawalRequested } from '../common/WithdrawalRequested';
import AdditionalInformationWrapper from '../../AdditionalInformationWrapper';

export const EditorialTransferOfferedAdditionalInfo = () => {
  const {
    submissionId,
    submissionContextId,
    workflowResponse,
    organizationId
  } = useSubmissionData();
  const { workflowData } = workflowResponse;
  const deadline = workflowData.currentDeadline;
  const [showContextModal, setShowContextModal] = useState(false);
  const [showGrantExtensionModal, setShowGrantExtensionModal] = useState(false);

  const isExtensionRequested =
    workflowData.deadlineExtensions?.status === 'requested';
  const isDeadlineOverdue =
    calculateDaysToDeadline(new Date(workflowData.currentDeadline ?? '')) < 1;

  return (
    <AdditionalInformationWrapper>
      <Accordion
        chakraAccordionProps={{
          width: '100%',
          defaultIndex: 0
        }}
        items={[
          {
            title: (
              <Flex alignItems={'flex-start'} gap={2}>
                <IconBadge icon={faBell} variant="neutral" />
                <Flex flexDirection={'column'} marginLeft={2}>
                  <Text textStyle="headingItem">Highlights</Text>
                  <Text textStyle="textContext">
                    Review key updates and other relevant information in this
                    phase.
                  </Text>
                </Flex>
              </Flex>
            ),
            content: (
              <Flex flexDirection="column" width="100%" gap={4}>
                <Flex gap={3} alignItems="center">
                  <IconBadge icon={faArrowsRotate} variant="attention" />
                  <Text textStyle="headingItem">Transfer Offer Undergoing</Text>
                  <ButtonText
                    marginLeft="auto"
                    onClick={() => setShowContextModal(true)}
                  >
                    View Details
                  </ButtonText>
                </Flex>

                <EditorialAuthorWithdrawalRequested />

                {(isExtensionRequested || isDeadlineOverdue) && (
                  <>
                    <Flex
                      borderTop="1px solid"
                      borderColor="neutralPrimaryBorder"
                    />
                    <Flex width="100%" gap={3} alignItems="start">
                      {isExtensionRequested ? (
                        <>
                          <IconBadge
                            icon={faHourglassHalf}
                            variant="attention"
                          />
                          <Flex flexDirection="column" flex={1}>
                            <Text textStyle="headingItem">
                              Author Transfer Extension Requested
                            </Text>
                          </Flex>
                        </>
                      ) : (
                        <>
                          <IconBadge icon={faArrowsRotate} variant="caution" />
                          <Flex flexDirection="column" flex={1}>
                            <Text textStyle="headingItem">
                              Transfer Deadline Overdue
                            </Text>
                            <Text>
                              The author will be unable to submit a revised
                              manuscript unless a deadline extension is given.
                            </Text>
                          </Flex>
                        </>
                      )}
                      <ButtonText
                        marginLeft="auto"
                        onClick={() => setShowGrantExtensionModal(true)}
                      >
                        {isExtensionRequested
                          ? 'Review Extension Request'
                          : 'Grant Extension'}
                      </ButtonText>
                    </Flex>
                  </>
                )}
              </Flex>
            )
          }
        ]}
      />

      {showContextModal && (
        <EditorialTransferOfferContextModal
          submissionId={submissionId}
          onClose={() => setShowContextModal(false)}
          deadline={deadline}
          role="editorial"
        />
      )}

      {showGrantExtensionModal && (
        <ExtendSubmissionDeadlineModal
          onClose={() => setShowGrantExtensionModal(false)}
          submissionId={submissionId}
          organizationId={organizationId}
          submissionContextId={submissionContextId}
          isExtensionRequested={isExtensionRequested}
          proposedDate={workflowData.deadlineExtensions?.proposedDate}
        />
      )}
    </AdditionalInformationWrapper>
  );
};
